import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import { Container, Fab, Grid2, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { clean } from "../actions/PDFExport";

import PDFReport from "../components/PDFReport";
import PDFBuilder from "../components/PDFBuilder";
import Icons from "../helpers/icons";

/* TODO: This will be a screen like MonthlyReportScreen, where:
- /pdfexport -> List of templates of pdf(report arrays with ID associated) to generate and download
- /pdfexport/create -> User can save and transform a report from other screen to a PDF 
- /pdfexport/:reportID -> Go to an existing template associated to that reportID
*/
const PDFExportScreen = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id: hotelID } = useSelector((state) => state.hotelID);

    let { reportId } = useParams();

    const [fabFixed, setFabFixed] = useState(false);
    const fabWrapperRef = useRef(null);

    const initialHotelIDRef = useRef(hotelID);
    useEffect(() => {
        // Only navigate away if there was a valid hotel at mount time and it changed
        if (
            initialHotelIDRef.current != null &&
            hotelID !== initialHotelIDRef.current
        ) {
            navigate(-1);
        }
    }, [hotelID, navigate]);

    useEffect(() => {
        return () => {
            dispatch(clean());
        };
    }, [dispatch]);

    // Switch FAB to fixed once it scrolls within 16px of the viewport top
    useEffect(() => {
        const el = fabWrapperRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting) {
                    setFabFixed(entry.boundingClientRect.top < 0);
                } else {
                    setFabFixed(false);
                }
            },
            { threshold: 0, rootMargin: "16px 0px 0px 0px" },
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            {reportId ? (
                <>
                    <PDFReport reportId={reportId} isCollapsible={false} />
                </>
            ) : (
                <>
                    <Container maxWidth={false}>
                        <Grid2 container direction={"column"}>
                            <Grid2 item sx={{ mt: 2, mb: 2 }} xs={12}>
                                <Typography variant="h4">PDF Export</Typography>
                            </Grid2>
                            <Typography
                                variant="subtitle1"
                                color="initial"
                                sx={{ mb: 2 }}
                            >
                                Preview and set your PDF: what you see here is
                                what the report will capture.
                            </Typography>
                        </Grid2>

                        {/* Exit FAB — in flow initially, fixed once it reaches 16px from top */}
                        <div
                            ref={fabWrapperRef}
                            style={{
                                display: "inline-flex",
                                marginBottom: 16,
                                visibility: fabFixed ? "hidden" : "visible",
                            }}
                        >
                            <Fab
                                variant="extended"
                                size="small"
                                color="primary"
                                onClick={() => window.history.back()}
                            >
                                <Icons.ArrowLeft sx={{ mr: 0.5 }} />
                                Exit PDF Export
                            </Fab>
                        </div>
                        {fabFixed && (
                            <Fab
                                variant="extended"
                                size="small"
                                color="primary"
                                onClick={() => window.history.back()}
                                sx={{
                                    position: "fixed",
                                    top: 72,
                                    left: 24,
                                    zIndex: 1300,
                                }}
                            >
                                <Icons.ArrowLeft sx={{ mr: 0.5 }} />
                                Exit PDF Export
                            </Fab>
                        )}

                        <PDFBuilder />
                    </Container>
                    <br />
                    <br />
                    <br />
                </>
            )}
        </>
    );
};
export default PDFExportScreen;
